import { FormContextValues } from '@dreryk/react-common';
import { PasswordInput as PasswordInputComponent } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const PASSWORD_FIELD_NAME = 'password';
const PASSWORD_MAX_LENGTH = 50;

export type PasswordFormBeanPart = { [PASSWORD_FIELD_NAME]: string | null };

type PasswordFieldProps = Pick<FormContextValues<PasswordFormBeanPart>, 'register'>;

export const PasswordField = (props: PasswordFieldProps): JSX.Element => {
   const controller = props.register(PASSWORD_FIELD_NAME, { required: true, maxLength: PASSWORD_MAX_LENGTH });

   return (
      <PasswordInputComponent label={nfzLoginTranslationKeys.nfzPassword} controller={controller} testId={'password'} />
   );
};
